import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { CONTENT_MAX_WIDTH } from '../constants';
import { useShareModal } from '../hooks/useShareModal';

export const Navigation = () => {
  const [shareModal, showShareModal] = useShareModal();

  return (
    <>
      {shareModal}
      <div style={{ padding: '5px 8px', backgroundColor: 'white' }}>
        <div
          style={{
            margin: 'auto',
            maxWidth: CONTENT_MAX_WIDTH,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <a
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 10,
              padding: 0,
              // color: '#3F79A4',
              textDecoration: 'none',
            }}
            href={window.location.pathname === '/' ? '#' : '/'}
          >
            {/* <img
              height="40"
              width="40"
              src="/logo-with-background.png"
              alt="SmartWallet"
            /> */}
            <h3>SmartWallet</h3>
          </a>
          {/* <button onClick={showShareModal}>
            <FontAwesomeIcon icon={faDownload} /> Share or Save
          </button> */}
        </div>
      </div>
    </>
  );
}; 